import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // Não logado → vai pro login
  if (!token) return <Navigate to="/login" replace />;

  // Role não permitida → 404
  if (allowedRoles && role && !allowedRoles.includes(role)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}